import { render, staticRenderFns } from "./PromotionActivitiesEvidencia.vue?vue&type=template&id=3d940c68&scoped=true&"
import script from "./PromotionActivitiesEvidencia.vue?vue&type=script&lang=js&"
export * from "./PromotionActivitiesEvidencia.vue?vue&type=script&lang=js&"
import style0 from "./PromotionActivitiesEvidencia.vue?vue&type=style&index=0&id=3d940c68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d940c68",
  null
  
)

export default component.exports